import type { Link } from './link.model';

export enum FooterAction {
  CONTACT_US = 'contact-us',
  ACCESSIBILITY_STATEMENT = 'accessibility-statement',
  TERMS_OF_USE = 'terms-of-use',
  PRIVACY_POLICY = 'privacy-policy',
  FAQ = 'faq'
}

export enum SubHeaderAction {
  CONTACT_US = 'contact-us',
  PRINT = 'print'
}

export interface FooterLink<T = FooterAction> extends Link {
  action?: T;
  iconName?: string;
}

export type SubHeaderLink = FooterLink<SubHeaderAction>;
